const templateReplace = (string: string, replacer: (str: string) => string): string => {
    const searchPattern = /{{[^}}]+}}/g;

    return string.match(searchPattern)
        ? string.replace(searchPattern, (key) => replacer(key.slice(2, -2)))
        : replacer(string);
};

export default templateReplace;
